import React, { useEffect } from "react";
import { Grid, Tabs, Tab, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-duotone-svg-icons";

/* Hook */
import useThemeContext from "../../hooks/useThemeSwitch.js";

/* Reducer */
import { setRootContainerWidth } from "../../reducers/layout/layoutReducer.js";

/* Styles */
import { useStyles } from "./styles.js";

/* Component */
import OneParkAdminContainer from "../../components/OneParkAdmin/OneParkAdminContainer.jsx";

const OneParkAdminPage = () => {
  const classes = useStyles();
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;

  useEffect(() => {
    layoutDispatch({ type: setRootContainerWidth, payload: false });
  }, [layoutDispatch]);

  return (
    <>
      <Grid item xs={12}>
        <Tabs
          centered
          className={classes.oneParkTab}
          variant="fullWidth"
          value="tabAdmin"
        >
          <Tab
            value="tabAdmin"
            icon={<FontAwesomeIcon icon={faCog} size="2xl" />}
            label="Admin"
            data-testid="onepark-admin-tab"
          />
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1" className={classes.subHeader}>
          ONEpark Admin
        </Typography>
      </Grid>
      <OneParkAdminContainer />
    </>
  );
};

export default OneParkAdminPage;
